export default __webpack_public_path__ + "static/media/maa-amet-logo.a1fa90cf.svg";